import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsConfirmMultiButton } from './generic-modal.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'ep-modal-confirm-multi-button',
    templateUrl: './modal-confirm-multi-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ModalConfirmMultiButtonComponent {
    options: ModalSettingsConfirmMultiButton;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsConfirmMultiButton;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    buttonClick(value: any) {
        this.modalState.modal.close(value);
    }
}